import React, { Component } from 'react';
import { Modal } from 'antd';

class DeteteRelative extends Component {

	// 确认删除
	handleOk = () => {
		const { onOk } = this.props;
		onOk && onOk();
	}

	// 取消删除
	handleCancel = () => {
		const { onCancel } = this.props;
		onCancel && onCancel();
	}

	render() {
		const { isShowDeleteModal } = this.props;
		return (
			<Modal
				title="提示"
				visible={isShowDeleteModal}
				cancelText="取消"
				okText="确认"
				onOk={this.handleOk}
				onCancel={this.handleCancel}>
				<div className="delete-relative">
					<p>确认要删除本题目和章节的关联关系吗？</p>
				</div>
			</Modal>
		)
	}
}

export default DeteteRelative;


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/check_beyond_level/modal/delete_relative.js